import { Navigate, Route, Routes } from "react-router-dom";
import CaseDedupDetailsPage from "../Components/AdminComponents/caseDedup/CaseDedupDetailsPage";
// import DemoCaseDup from "../Components/AdminComponents/caseDedup/demo/DemoCaseDup";
import Summary from "../Components/AdminComponents/Duplication/Summary";
import AdminLayout from "../pages/Admin/AdminLayout";
import CaseDedupMain from "../pages/Admin/caseDedup/CaseDedupMain";
import Duplication from "../pages/Admin/Duplication/Index";
import EditCodeMainPage from "../pages/Admin/EditCodes/EditCodeMainPage";
import Security from "../pages/Admin/EditSecurity/Security";
import ExportConfigPage from "../pages/Admin/ExportConfig/ExportConfigPage";
import AdminHealthTopicsLayout from "../pages/Admin/SampleDataEdit/Adminhealthtopicslayout";
import CaseProcessing from "../pages/Admin/SuperRole/CaseProcessing";
import ImportConfig from "../pages/Admin/SuperRole/ImportConfig";
import SuperRoleLayout from "../pages/Admin/SuperRole/SuperRoleLayout";
import PatientPage from "../pages/Case/index";
import CaseDetailsPage from "../pages/CaseDetails/CaseDetailsPage";
import CaseLinksPage from "../pages/EDSS/CaseLinks/CaseLinksPage";
import CaseNotesViewPage from "../pages/EDSS/CaseNotesView/CaseNotesViewPage";
import CaseView from "../pages/EDSS/CaseView/CaseView";
import EdssLayout from "../pages/EDSS/EdssLayout";
import EdssPage from "../pages/EDSS/EdssPage";
import PersonView from "../pages/EDSS/PersonView/PersonView";
import GptecFAQ from "../pages/FAQ/GptecFAQ";
import HealthTopicsLayout from "../pages/HealthTopics/HealthTopicsLayout";
import Home from "../pages/HomePage/Home";
import ImportRosterPage from "../pages/ImportRosterPage/ImportRosterPage.jsx";
import ModelBuilder from "../pages/Model-Builder/ModelBuilder";
import ProtectedAdminRoute from "../utils/ProtectedAdminRoute";
import ProtectedRoute from "../utils/ProtectedRoute";
import ProtectRouteBasedOnRoles from "../utils/ProtectRouteBasedOnRoles.jsx";
function GptRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/index" />} />
      <Route path="/index" element={<Home />} />
      <Route
        path="/Admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<AdminHealthTopicsLayout />} />
        {/* <Route path="data-edit" element={<EditDataPage />} /> */}
        <Route path="data-edit" element={<AdminHealthTopicsLayout />} />
        {/* <Route path="edit-model" element={<EditModel />} /> */}
        <Route path="edit-codes" element={<EditCodeMainPage />} />
        <Route path="security" element={<Security />} />
        <Route path="summary/:id" element={<Summary />} />
        <Route path="duplicate" element={<Duplication />} />
        <Route path="caseDedup" element={<CaseDedupMain />} />
        <Route
          path="caseDedup/:id/:personID"
          element={<CaseDedupDetailsPage />}
        />

        <Route path="edit-edss-model" element={<ModelBuilder />} />
        <Route path="super-role" element={<SuperRoleLayout />}>
          <Route index element={<ExportConfigPage />} />
          <Route path="export-config" element={<ExportConfigPage />} />
          <Route path="import-config" element={<ImportConfig />} />
          <Route path="case-proccessing" element={<CaseProcessing />} />
        </Route>
      </Route>
      {/* <Route path="demo" element={<DemoCaseDup />} /> */}

      {/* Protected Cases Route */}
      <Route
        path="/Source"
        element={
          <ProtectedRoute>
            <PatientPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Import-roster"
        element={
          <ProtectRouteBasedOnRoles
            requiredRoles={["import"]}
            requireAll={false}
          >
            <ImportRosterPage />
          </ProtectRouteBasedOnRoles>
        }
      />
      <Route path="/Investigate" element={<EdssPage />} />
      <Route path="/personView/:personID" element={<PersonView />} />
      <Route path="/CaseView" element={<EdssLayout />}>
        <Route index path="/CaseView/:id/:personID" element={<CaseView />} />
        <Route path="caselinks/:id/:personID" element={<CaseLinksPage />} />
        {/* <Route path="personView/:id" element={<PersonView />} /> */}
        <Route path="caseNotes/:id" element={<CaseNotesViewPage />} />
      </Route>

      {/* ================== */}
      <Route path="/Cases/:id/:source" element={<CaseDetailsPage />} />
      {/* <Route path="/Data" element={<DataHomePage />} /> */}
      <Route path="/Monitor" element={<HealthTopicsLayout />} />
      <Route path="/FAQ" element={<GptecFAQ />} />
    </Routes>
  );
}

export default GptRoutes;
